import { makeObservable, action, computed, runInAction } from "mobx";
import firebaseAgent from "../api/firebaseagent";
import { Booking } from "../models/booking";
import { BaseStore } from "./baseStore";
import { serverTimestamp } from "firebase/firestore";
import { RootStore, store } from "./rootStore";

export default class BookingStore extends BaseStore<Booking> {
    
    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            createOrder: action,
            clearLastBooking: action,
            recentBooking: computed
        });
    }

    // Link to the bookingService in your firebaseAgent
    protected getService() {
        return firebaseAgent.bookingService;
    }

    /**
     * core Logic: Create order, clear cart, and set selectedItem for receipt
     */
    createOrder = async (userId: string, cartItems: any[], total: number, couponCode?: string, 
        discountAmount?: number) => {
        const newBooking: Booking = {
            receiptNumber: `REC-${Math.floor(100000 + Math.random() * 900000)}`,
            userId: userId,
            items: [...cartItems],
            total: total, // Final price after coupon
            subtotal: total + (discountAmount || 0), // Original price
            couponCode: couponCode || null,
            discountAmount: discountAmount || 0,
            status: 'Pending',
            orderDate: serverTimestamp(),
            whatsappSent: true,
            actionDate: serverTimestamp(),
            actionBy: userId
        };

        try {
            // 1. Register booking in Firestore
            const savedBooking = await this.register(newBooking);

            // 2. Clear user cart in Firestore and Local Store after successful booking
            await store.cartStore.clearCart(userId);

            // 3. Clear the coupon state after successful checkout
            runInAction(() => {
                this.rootStore?.couponStore.clearCoupon();
                this.selectedItem = savedBooking; // Set for receipt UI
            });

            return savedBooking;
        } catch (error) {
            console.error("Order processing failed:", error);
            throw error;
        }
    }

    clearLastBooking = () => {
        runInAction(() => {
            this.selectedItem = null;
        });
    }

    get recentBooking() {
        return this.selectedItem;
    }
}